module.exports = __webpack_public_path__ + "img/logo-le-postiche.jpg";